const LAST_RELOAD_KEY = 'spcfy:stale-chunk-reload'
const MIN_RELOAD_INTERVAL_MS = 60_000

/** Reloads the page when a lazy chunk fails to load, which is how a tab still running a previous build meets a deploy. */
export const reloadOnStaleChunk = (win: Window = window): void => {
  win.addEventListener('vite:preloadError', (event) => {
    // A chunk that is gone for good would otherwise reload forever; without storage there is no guard, so don't reload.
    try {
      const lastReload = Number(win.sessionStorage.getItem(LAST_RELOAD_KEY)) || 0
      if (Date.now() - lastReload < MIN_RELOAD_INTERVAL_MS) {
        return
      }
      win.sessionStorage.setItem(LAST_RELOAD_KEY, String(Date.now()))
    } catch {
      return
    }
    event.preventDefault()
    win.location.reload()
  })
}
